import {getStatusesByIds} from 'mattermost-redux/actions/users';
import {selectDirectChannelsForSidebar} from 'mattermost-redux/selectors/entities/channels';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/users';

import {loadCustomEmojisForCustomStatusesByUserIds} from 'actions/emoji_actions';
import store from 'stores/redux_store';
import {Constants} from 'utils/constants';
import {getDmUsers} from 'mattermost-redux/selectors/entities/getDmUsers';
import {getUserIdFromChannelName} from 'mattermost-redux/utils/channel_utils';
import {TimeLogger} from 'utils/logger';

export function loadStatusesForSidebar() {
    return (dispatch, getState) => {
        const state = getState();

        const currentUserId = getCurrentUserId(state);
        const userIds = [currentUserId];
        const channels = selectDirectChannelsForSidebar(state);
        channels.forEach((channel) => {
            const teammateId = getUserIdFromChannelName(currentUserId, channel.name);
            if (teammateId && teammateId !== currentUserId) {
                userIds.push(teammateId);
            }
        });

        dispatch(loadStatusesByIds(userIds));
    };
}

export function loadStatusesForProfilesList(users) {
    return (dispatch) => {
        if (users == null) {
            return {data: false};
        }

        const statusesToLoad = [];
        for (let i = 0; i < users.length; i++) {
            statusesToLoad.push(users[i].id);
        }

        dispatch(loadStatusesByIds(statusesToLoad));

        return {data: true};
    };
}

export function loadStatusesByIds(userIds) {
    return (dispatch) => {
        if (userIds.length === 0) {
            return {data: false};
        }

        if (userIds[0] === '') {
            TimeLogger.error('trying to load statuses with empty users');
            return {data: false};
        }

        dispatch(getStatusesByIds(userIds));
        dispatch(loadCustomEmojisForCustomStatusesByUserIds(userIds));
        return {data: true};
    };
}

/**
 *
 * @param {import('@mattermost/types/users').UserProfile[]} users
 */
export function loadProfilesMissingStatus(users) {
    return (dispatch, getState) => {
        const state = getState();
        const statuses = state.entities.users.statuses;

        const dmUsers = getDmUsers(state);

        const missingStatusByIds = users.
            filter((user) => !statuses[user.id] && dmUsers.has(user.id)).
            map((user) => user.id);

        if (missingStatusByIds.length === 0) {
            return {data: false};
        }

        dispatch(getStatusesByIds(missingStatusByIds));
        dispatch(loadCustomEmojisForCustomStatusesByUserIds(missingStatusByIds));
        return {data: true};
    };
}

let intervalId = '';

export function startPeriodicStatusUpdates() {
    clearInterval(intervalId);

    intervalId = setInterval(
        () => {
            store.dispatch(loadStatusesForSidebar());
        },
        Constants.STATUS_INTERVAL,
    );
}

export function stopPeriodicStatusUpdates() {
    clearInterval(intervalId);
}
